import React from 'react';

import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

const VersionSetCell = ({ rowData = {}, isDisabled }) => (
  <OverflowTooltip
    autoTipOnEllipsis
    style={{ zIndex: 9999 }}
    content={rowData.versionSet?.name}
    variant={OverflowTooltip.VARIANTS.LIGHT}
  >
    <span style={{ color: isDisabled && theme.colors.charcoal500 }}>
      {rowData.versionSet?.name || ''}
    </span>
  </OverflowTooltip>
);

export default VersionSetCell;
